/**
 * @file Shared select visual state helpers for modal forms.
 */

import { appData } from '../../app/state/state.js';
import {
    isColorDark,
} from "../utils/displayUtils.js";

/**
 * Applies placeholder and configured color styles to a modal select.
 * @param {HTMLSelectElement} select Select element to style.
 * @param {string} itemType Current form item type.
 * @returns {void}
 */
export function updateSelectStyles(select, itemType) {
    if (!select) {return;}

    // 1. Handle Placeholder Color (Gray vs Normal)
    if (!select.value) {
        select.classList.add('text-gray-500', 'dark:text-gray-400');
        select.classList.remove('text-gray-700', 'text-gray-900', 'dark:text-gray-200');
    } else {
        select.classList.remove('text-gray-500', 'dark:text-gray-400');
        select.classList.add('text-gray-700', 'dark:text-gray-200');
    }

    // 2. Handle Status/Urgency Background Colors
    const name = select.name;
    let color = null;
    const val = select.value;

    if (name === 'priority') {
        color = appData?.config?.priorities?.find(p => p.id === val)?.color;
    } else if (name === 'status') {
        const config = appData?.config || {};
        let list = [];
        if (itemType === 'patient') {list = config.patientStatus || [];}
        else if (itemType === 'project') {list = config.projectStatus || [];}
        else if (itemType === 'task') {list = config.taskStatus || [];}
        else if (itemType === 'asset_issue') {list = config.issueStatus || [];}
        else if (itemType === 'asset_service') {list = config.equipmentStatus || [];}
        color = list.find(s => s.id === val)?.color;
    } else if (name === 'equipment_status') {
        color = appData?.config?.equipmentStatus?.find(s => s.id === val)?.color;
    }

    if (color) {
        select.style.backgroundColor = color;
        select.style.color = isColorDark(color) ? 'white' : '#1f2937'; // gray-800
        select.style.borderColor = 'transparent';
    } else {
        select.style.backgroundColor = '';
        select.style.color = '';
        select.style.borderColor = '';
    }
}
